import 'moment/locale/th'
import React, { useState, useEffect, Fragment } from 'react'
import callApi from '../../helpers/callapi'
import moment from 'moment'
import { Card, Form, Row, Col, Button, Table, Badge, Tab, Nav, Pagination } from 'react-bootstrap'
// Components
import CONSTANTS from '../../constants/constants'
import ModalDetail from './ModalDetail'

const ORDER_STATUS = CONSTANTS.orderStatus
const ORDER_LABEL = CONSTANTS.orderLabels
const BANK = CONSTANTS.banks

const PAYMENTMETHODS = {
  cc: 'Credit Card',
  transfer: 'Bank Transfer',
  admin: 'Created By Admin',
  credit: 'Credit',
}

moment.locale('th')

const Agent = () => {
  const [loading, setLoading] = useState(false)
  const [agents, setAgents] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [status, setStatus] = useState('all')
  const [active, setActive] = useState(1)
  const [showModalDetail, setShowModalDetail] = useState(false)
  const [agentId, setAgentId] = useState('')

  let items = []
  for (let number = 1; number <= 10; number++) {
    items.push(
      <Pagination.Item
        key={number}
        active={number === active}
        onClick={() => {
          if (number > currentPage) {
            onChangePage(number, {
              lastItem: agents[agents.length - 1].id,
            })
          } else {
            onChangePage(currentPage - 1, {
              endItem: agents[0].id,
            })
          }
          setActive(number)
        }}
      >
        {number}
      </Pagination.Item>,
    )
  }

  // const [creditCount, setCreditCount] = useState()
  const fetchAgents = async (query) => {
    try {
      setLoading(true)

      const { count, results: agents } = await callApi({
        url: '/agents',
        query,
      })
      setAgents(agents)

      setLoading(false)
    } catch (error) {
      setAgents([])
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchAgents()
  }, [])

  const onChangePage = (page, requestQuery) => {
    setCurrentPage(page)
    fetchAgents(requestQuery)
  }

  const _TabData = [
    { title: 'ทั้งหมด', value: 'all' },
    { title: 'Agent', value: 'agent' },
    { title: 'Master Agent', value: 'master' },
    { title: 'Platinum Agent', value: 'platinum' },
    { title: 'Super Master', value: 'super-master' },
    { title: 'Sub Master', value: 'sub-master' },
  ]

  return (
    <Fragment>
      <Card>
        <Card.Header>
          <Card.Title>Lotteries</Card.Title>
        </Card.Header>
        <Card.Body>
          <Tab.Container defaultActiveKey={_TabData[0].value}>
            <Nav as="ul" className="nav-pills mb-4 light">
              {_TabData.map((data, i) => {
                return (
                  i !== _TabData.length && (
                    <Nav.Item as="li" key={i}>
                      <Nav.Link
                        eventKey={data.value}
                        onClick={async () => {
                          setStatus(data.value)
                          if (data.value === 'all') {
                            fetchAgents({})
                          } else {
                            fetchAgents({ type: data.value })
                          }
                        }}
                      >
                        {data.title}
                      </Nav.Link>
                    </Nav.Item>
                  )
                )
              })}
            </Nav>
          </Tab.Container>
          <Form>
            <Form.Group>
              <Row>
                <Col sm={12} md={6} lg={4}>
                  <Form.Control type="text" placeholder="ชื่อลูกค้า" />
                </Col>
                <Col sm={12} md={6} lg={4}>
                  <Form.Control type="text" placeholder="เบอร์โทรศัพท์/รหัสสมาชิก" />
                </Col>
                <Col sm={12} md={12} lg={4}>
                  <Row>
                    <Col md={6} lg={0}></Col>
                    <Col md={6} lg={12}>
                      <Button variant="danger light" className="w-50">
                        ล้างตัวกรอง
                      </Button>
                      <Button variant="primary light" className="w-50">
                        ค้นหา
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form.Group>
          </Form>
          <Table responsive striped bordered className="verticle-middle">
            <thead>
              <tr>
                <th>รหัส</th>
                <th>ชื่อตัวแทน</th>
                <th>ประเภท</th>
                <th>ค่าคอม</th>
                <th>จำนวนลอตเตอรี่</th>
                <th>รายได้</th>
                <th>เงินคงเหลือ</th>
                <th>Master Agent</th>
              </tr>
            </thead>
            <tbody>
              {agents.map((agent, i) => {
                return (
                  <tr key={i}>
                    <td>
                      <Badge
                        variant="primary light"
                        onClick={() => {
                          setShowModalDetail(true)
                          setAgentId(agent.id)
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        {agent.agentId}
                      </Badge>
                    </td>
                    <td>
                      {agent.firstName} {agent.lastName}
                    </td>
                    <td>{agent.type}</td>
                    <td>{agent.commission}</td>
                    <td>{agent.totalLotteryCount ? agent.totalLotteryCount : 0}</td>
                    <td>{agent.totalMoney ? agent.totalMoney : 0}</td>
                    <td></td>
                    <td>
                      {agent.masterFirstName} {agent.masterLastName}
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </Table>
          <div style={{ textAlign: 'right', marginTop: 15 }}>
            {currentPage > 1 && (
              <Badge
                variant="primary light"
                onClick={() =>
                  onChangePage(currentPage - 1, {
                    endItem: agents[0].id,
                  })
                }
                style={{ cursor: 'pointer' }}
              >
                {'<'} หน้าก่อนหน้า
              </Badge>
            )}{' '}
            <Badge variant="primary light" style={{ cursor: 'pointer' }}>
              {currentPage}
            </Badge>{' '}
            {agents.length === 20 && (
              <Badge
                variant="primary light"
                style={{ cursor: 'pointer' }}
                onClick={() =>
                  onChangePage(currentPage + 1, {
                    lastItem: agents[agents.length - 1].id,
                  })
                }
              >
                หน้าถัดไป {'>'}
              </Badge>
            )}
          </div>
          <ModalDetail
            showModalDetail={showModalDetail}
            setShowModalDetail={setShowModalDetail}
            agentId={agentId}
            fetchAgents={fetchAgents}
          />
        </Card.Body>
      </Card>
    </Fragment>
  )
}

export default Agent
